import React, { createContext, useContext, ReactNode } from 'react';
import { useBrandTheme, BrandTheme, ThemeMode } from '@/hooks/useBrandTheme';

interface BrandThemeContextType {
  currentBrand: string;
  theme: BrandTheme;
  themeMode: ThemeMode;
  switchBrand: (brandKey: string, mode?: ThemeMode) => void;
  switchThemeMode: (mode: ThemeMode) => void;
  getAvailableBrands: () => string[];
  applyBrandTheme: (brandTheme: BrandTheme, brandKey: string, mode?: ThemeMode) => void;
  clearUserPreferences: () => void;
  getThemeSource: () => string;
}

const BrandThemeContext = createContext<BrandThemeContextType | undefined>(undefined);

export const BrandThemeProvider = ({ children }: { children: ReactNode }) => {
  const brandTheme = useBrandTheme();

  return (
    <BrandThemeContext.Provider value={brandTheme}>
      {children}
    </BrandThemeContext.Provider>
  );
};

export const useBrandThemeContext = () => {
  const context = useContext(BrandThemeContext);
  if (context === undefined) {
    throw new Error('useBrandThemeContext must be used within a BrandThemeProvider');
  }
  return context;
}; 